import React from "react"
import BakeryPage from "@components/Bakery/index";
import "@styles/styles.css";
import "@styles/utils.css";

export default function Mystics() {
  return <BakeryPage/>
}
